var TIMEOUT_FRAME = 1000 / 60;
var setTimeoutPolyfill = function setTimeoutPolyfill(callback) {
  setTimeout(callback, TIMEOUT_FRAME);
};
var requestAnimationFrame = global.requestAnimationFrame || global.webkitRequestAnimationFrame || global.mozRequestAnimationFrame || global.oRequestAnimationFrame || global.msRequestAnimationFrame || setTimeoutPolyfill;
export default requestAnimationFrame;